define('bizzabo/models/EventDetails',[
    'GSModel',
    'bizzabo/bzapi',
    'bizzabo/config',
    'bizzabo/utils',
    'bizzabo/consts',
    'backbone',
    'backbone-validation',
    'underscore',
    'bizzabo/models/ValidationObject',
    'bizzabo/models/Tier',
    'bizzabo/models/Tiers',
    'timezoneJS',
    'bizzabo/models/Global'
], function(
    GSModel,
    BZAPI,
    CONFIG,
    UTILS,
    Consts,
    Backbone,
    BackboneValidation,
    _,
    ValidationObject,
    Tier,
    Tiers,
    timezoneJS,
    Global
    ) {

    var EventDetails = GSModel.extend({

        shouldFetch : true,
        validationObject : undefined,

        getInternalWebsiteBaseUrl: function(options) {
            var options = options || {};
            var noUniqueName = !!options.noUniqueName;
            var whitelabel = '//'+ this.get('whitelabelUrl');
            var uniqueName = this.get('unique-name');
            var bizzabo = noUniqueName ? CONFIG.EVENTS_URL : CONFIG.EVENTS_URL + '/' + uniqueName;
            var independent = bizzabo;
            var type = this.get('websiteType');

            return {
                independent: independent,
                whitelabel: whitelabel,
                bizzabo: bizzabo
            }[type];
        },

        sync : function(method, model, options) {
            if (method == 'read') {
                BZAPI.getEventDetails(model.id, function(data) {
                    options.success && options.success(data, options);
                    model.setFlagsAfterSync();
                    model.shouldFetch = false;
                }, options.error);
            } else if (method == 'create') {
                var modelAttrs = model.foldVenue(model.toJSON());
                BZAPI.createEvent(modelAttrs, function(data) {
                    model.set('last-saved', new Date().getTime());
                    options.success && options.success(data, options);
                    model.setFlagsAfterSync();
                    model.shouldFetch = false;
                }, options.error);
            } else if (method == 'update') {
                var modelAttrs = model.foldVenue(model.toJSON());
                modelAttrs = _.pick(modelAttrs, 'splash-screen-url', 'tier-configuration');
                BZAPI.updateEventDetails(model.get('account-id'), model.id, modelAttrs, function(data) {
                    model.set('last-saved', new Date().getTime());
                    options.success && options.success(data, options);
                    model.setFlagsAfterSync();
                    model.shouldFetch = false;
                }, options.error);
            } else if (method == 'publish') {
                BZAPI.publishEvent(model.id, function(data) {
                    options.success && options.success(data, options);
                    model.setFlagsAfterSync();
                }, options.error);
            } else if (method == 'enable-poll-registration-system') {
                BZAPI.enablePollingRegistrationSystem(model.id, function(data) {
                    options.success && options.success(data, options);
                }, options.error);
            } else if (method == 'disable-poll-registration-system') {
                BZAPI.disablePollingRegistrationSystem(model.id, function(data) {
                    options.success && options.success(data, options);
                }, options.error);
            }
        },

        parse : function(response) {
            var parsed = this.unfoldAggregatedData(this.unfoldVenue(response));
            var assimilated = this.attributes ? this.assimilateJson(parsed).attributes : response;
            return assimilated;
        },

        defaults : {
            'time-zone-id' : 'America/New_York',
            'has-official-organizer' : true,
            'privacy' : 'public',
            'uniqueNameValid' : true
        },

        initialize : function() {
            this.on( "change:unique-name", this.validateUniqueName);
            var tzDate = new timezoneJS.Date();
            var nowDateText = this.toDateText(tzDate.getTime());
            if (!this.has('start-date')) {
                this.setStartDate(nowDateText);
            }
            if (!this.has('end-date')) {
                this.setEndDate(nowDateText);
            }

            var thisTiers = this.get("tier-configuration");
            if (_.isUndefined(thisTiers) || _.isArray(thisTiers)) {
                var newTiers = new Tiers(thisTiers || Tiers.prototype.defaultTiers);
                this.set({
                    'tier-configuration' : newTiers
                });
            }

            this.validationObject = new ValidationObject(this);
        },

        toDateText : function(millis, timeZone) {
            var dateText = '';
            timeZone = timeZone || this.get('time-zone-id');
            if (!_.isNaN(millis)) {
                var padding_zero = function(x, n) {
                    return String('000000' + x).slice(-1 * n)
                };
                var tzDate = new timezoneJS.Date(millis);
                tzDate.setTimezone(timeZone);
                tzDate.setTime(millis);
                dateText = padding_zero(tzDate.getMonth() + 1, 2) + '/' + padding_zero(tzDate.getDate(), 2) + '/' + tzDate.getFullYear();
            }
            return dateText;
        },

        getters : {
            'startDate' : function() {
                return this.toDateText(this.get('start-date'));
            },
            'endDate' : function() {
                return this.toDateText(this.get('end-date'));
            },
            'lastSaved' : function() {
                var dateText = undefined;
                var millis = this.get('last-saved');
                if (!_.isNaN(millis)) {
                    var date = new Date(millis);
                    dateText = date.getHours() + ':' + date.getMinutes();
                }
                return dateText;
            }
        },

        setters : {
            'custom-button-1-url' : function(value) {
                if(value == '') {
                    this.unset('custom-button-1-url');
                    return;
                }
                var valueWithHTTP = 'http://' + value;
                return (Backbone.Validation.patterns.url.test(valueWithHTTP)) ? valueWithHTTP : value;
            },
            'custom-button-1-name' : function(value) {
                if(value == '') {
                    this.unset('custom-button-1-name');
                    return;
                }
                return value;
            },
            'custom-button-2-url' : function(value) {
                if(value == '') {
                    this.unset('custom-button-2-url');
                    return;
                }
                var valueWithHTTP = 'http://' + value;
                return (Backbone.Validation.patterns.url.test(valueWithHTTP)) ? valueWithHTTP : value;
            },
            'custom-button-2-name' : function(value) {
                if(value == '') {
                    this.unset('custom-button-2-name');
                    return;
                }
                return value;
            },
            'custom-button-3-url' : function(value) {
                if(value == '') {
                    this.unset('custom-button-3-url');
                    return;
                }
                var valueWithHTTP = 'http://' + value;
                return (Backbone.Validation.patterns.url.test(valueWithHTTP)) ? valueWithHTTP : value;
            },
            'custom-button-3-name' : function(value) {
                if(value == '') {
                    this.unset('custom-button-3-name');
                    return;
                }
                return value;
            },
            'has-official-organizer' : function(value) {
                return value == 'true' || value === true;
            },
            'privacy' : function(value) {
                if (value == 'public') {
                    this.unset('access-code');
                }
                return value;
            }
        },

        publish : function(options) {
            this.sync('publish', this, options);
        },

        enablePollingRegistrationSystem : function(options) {
            options = options || {};
            options.success = options.success || function() {};
            options.error = options.error || function() {};
            this.sync('enable-poll-registration-system', this, options);
        },

        disablePollingRegistrationSystem : function(options) {
            options = options || {};
            options.success = options.success || function() {};
            options.error = options.error || function() {};
            this.sync('disable-poll-registration-system', this, options);
        },

        validateUniqueName: function() {
            var thisModel = this;
            BZAPI.checkUniqueName(this.get('unique-name'),
                function(response) {
                    if (response['event-id'] == thisModel.get('id')) {
                        thisModel.set('uniqueNameValid', true);
                    } else {
                        thisModel.set('uniqueNameValid', response.available);
                    }
                    thisModel.trigger('uniqueNameValidation');
                }
            );
        },

        validation : {
            'unique-name': [{
                required : true,
                msg: 'Web address is required'
            },
                {
                    maxLength : 30,
                    msg : 'Web address is too long'
                },
                {
                    fn: function(value, attr, computedState) {
                        var isValid = computedState.uniqueNameValid;
                        if (!isValid) {
                            return 'Web address is not available';
                        }
                    }
                },
                {
                    fn : function(value) {
                        if (!/^[A-Za-z0-9_-]+$/g.test(value)) {
                            return 'Web address must not contain spaces or special characters';

                        }
                    }
                }
            ],
            name : [
                {
                    required : true,
                    msg : 'Name is required'
                },
                {
                    maxLength : 1000,
                    msg : 'Name is too long'
                }
            ],
            keywords : {
                required : false,
                maxLength : 20,
                msg : 'Search name is too long'
            },
            'description' : {
                required : false,
                maxLength : 3500,
                msg : 'Description is too long'
            },
            'venue-name' : {
                required : false,
                maxLength : 150,
                msg : 'Venue name is too long'
            },
            'venue-display-address' : {
                required : false,
                maxLength : 300,
                msg : 'Address is too long'
            },
            'twitter-hashtag' : [
                {
                    required : false,
                    maxLength : 50,
                    msg : 'Twitter hashtag is too long'
                },
                {
                    fn : function(value) {
                        if (/[\s@#]/g.test(value)) {
                            return 'Twitter hashtag must not contain spaces, # or @';
                        }
                    }
                }
            ],
            'twitter-handle' : [
                {
                    required : false,
                    maxLength : 15,
                    msg : 'Twitter name too long'
                },
                {
                    fn : function(value) {
                        if (/[\s@#]/g.test(value)) {
                            return 'Twitter name must not contain spaces, # or @';
                        }
                    }
                },
                {
                    pattern : 'twitterScreenName',
                    msg : 'Twitter name is invalid'
                }
            ],
            'custom-button-1-name' : {
                required : function(value, attr, computedState) {
                    return _.isEmpty(value) && computedState['custom-button-1-url'];
                },
                maxLength : 34,
                msg : 'Link name is invalid'
            },
            'custom-button-1-url' : [{
                    required : function(value, attr, computedState) {
                        return _.isEmpty(value) && computedState['custom-button-1-name'];
                    },
                    maxLength : 255,
                    pattern : 'url',
                    msg : 'Link address is invalid'
                }
            ],
            'custom-button-2-name' : {
                required : function(value, attr, computedState) {
                    return _.isEmpty(value) && computedState['custom-button-2-url'];
                },
                maxLength : 34,
                msg : 'Link name is invalid'
            },
            'custom-button-2-url' : [{
                    required : function(value, attr, computedState) {
                        return _.isEmpty(value) && computedState['custom-button-2-name'];
                    },
                    maxLength : 255,
                    pattern : 'url',
                    msg : 'Link address is invalid'
                }
            ],
            'custom-button-3-name' : {
                required : function(value, attr, computedState) {
                    return _.isEmpty(value) && computedState['custom-button-3-url'];
                },
                maxLength : 34,
                msg : 'Link name is invalid'
            },
            'custom-button-3-url' : [{
                required : function(value, attr, computedState) {
                    return _.isEmpty(value) && computedState['custom-button-3-name'];
                },
                maxLength : 255,
                pattern : 'url',
                msg : 'Link address is invalid'
            }
            ],
            'access-code' : [
                {
                    required : function() {
                        return (this.get('privacy') !== 'public');
                    },
                    maxLength : 8,
                    msg : 'Access code is required'
                }
            ],
            'support-email' : {
                required : true,
                maxLength : 100,
                pattern : 'email',
                msg : 'Contact email address is invalid'
            },
            'tier-configuration' : function(value, attr, computedState) {
                var tiersValidation = new Tiers(value);
                return tiersValidation.isValid() ? null : 'Tiers are invalid';
            }
        },

        numberOfDays: function() {
            var startDate = this.get("local-start-date");
            var endDate = this.get("local-end-date");
            return UTILS.getDiffInDays(startDate, endDate);
        },

        toStartDate : function(dateText, timeZone) {
            var tzDate = new timezoneJS.Date(dateText, timeZone);
            tzDate.setHours(0);
            tzDate.setMinutes(0);
            tzDate.setSeconds(0);
            tzDate.setMilliseconds(0);
            return tzDate.getTime();
        },

        toEndDate : function(dateText, timeZone) {
            var tzDate = new timezoneJS.Date(dateText, timeZone);
            tzDate.setHours(23);
            tzDate.setMinutes(59);
            tzDate.setSeconds(59);
            tzDate.setMilliseconds(0);
            return tzDate.getTime();
        },

        setStartDate : function(dateText) {
            var millis = this.toStartDate(dateText, this.get('time-zone-id'));
            this.set('start-date', millis);
        },

        setEndDate : function(dateText) {
            var millis = this.toEndDate(dateText, this.get('time-zone-id'));
            this.set('end-date', millis);
        },

        setDates : function(startDateText, endDateText, timeZone) {
            this.set('time-zone-id', timeZone);
            this.setStartDate(startDateText);
            this.setEndDate(endDateText);
        },

        isLive : function() {
            return this.get('status') == 'published';
        },

        isPendingApproval : function() {
            return this.get('status') == 'pending-approval';
        },

        isPublished : function() {
            return this.isLive() || this.isPendingApproval();
        },

        // Push Notifications

        sendPushNotificationsStatus : {
            Allowed : 0,
            NotLive : 1,
            NoMessagesLeft : 2,
            NotEnoughAttendees : 3
        },

        canSendPushNotifications : function() {
            if (this.isNew() || !this.isLive()) {
                return this.sendPushNotificationsStatus.NotLive;
            }

            var noMessagesLeft = (this.get('aggregated-data-push-notifications-left') <= 0);
            if (noMessagesLeft) {
                return this.sendPushNotificationsStatus.NoMessagesLeft;
            }

            var minAttendeesForPushNotifications = this.get('min-attendees-for-push') || 15;
            var notEnoughAttendees = (this.get('aggregated-data-rsvp-count') < minAttendeesForPushNotifications);
            if (notEnoughAttendees) {
                return this.sendPushNotificationsStatus.NotEnoughAttendees;
            }

            return this.sendPushNotificationsStatus.Allowed;
        },

        buildCommunity : function() {
            if (this.isNew()) {
                return;
            }

            BZAPI.buildCommunity(this.id);
        },

        removeCommunity : function() {
            if (this.isNew()) {
                return;
            }

            BZAPI.removeCommunity(this.id);
        },

        // Fold nested data

        foldVenue : function(attrs) {
            attrs.venue = {};

            var attrsToDelete = [];
            var prefix = 'venue-';
            _.each(attrs, function(value, key) {
                if (key.indexOf(prefix) === 0) {
                    var newKey = key.substr(prefix.length);
                    attrs.venue[newKey] = value;
                    attrsToDelete.push(key);
                }
            });

            _.each(attrsToDelete, function(key) {
                delete attrs[key];
            });

            return attrs;
        },

        unfoldVenue : function(attrs) {
            return UTILS.unfoldAttribute(attrs, 'venue');
        },

        unfoldAggregatedData : function(attrs) {
            return UTILS.unfoldAttribute(attrs, 'aggregated-data');
        }

    });

    return EventDetails;

});
